import React, { useState } from "react";
import toast from "react-hot-toast";
import { authApiService } from "../../../../api/api";
import { BatteryCreateDto } from "../../../../types/battery.type";
import ModalBottomButtons from "../buttons/ModakBottomButtons/ModalBottomButtons";
import EditInput from "../inputs/EditInput/EditInput";
import styles from "./styles.module.scss";

interface Props {
  onClose: () => void;
  onApply: () => void;
}

const AddBatteryForm: React.FC<Props> = (props) => {
  const [macAddress, setMacAddress] = useState<string>("");
  const [name, setName] = useState<string>("");
  const [note, setNote] = useState<string>("");
  const [deltaVoltage, setDeltaVoltage] = useState<string>("");
  const [lastLocation, setLastLocation] = useState<
    "terminal" | "warehouse" | "client" | "unknown"
  >("warehouse");
  const [lastLocationId, setLastLocationId] = useState<string>("");

  const onApplyCreateBattery = async () => {
    if (!macAddress.trim() || !name.trim()) {
      toast.error("Заповніть обовʼязкові поля");
      return;
    }

    if (deltaVoltage && Number.isNaN(Number(deltaVoltage))) {
      toast.error("Різниця напруги має бути числом");
      return;
    }

    try {
      const body: BatteryCreateDto = {
        macAddress: macAddress.trim(),
        name: name.trim(),
        note: note.trim() || undefined,
        deltaVoltage: deltaVoltage ? Number(deltaVoltage) : null,
        lastLocation,
        lastLocationId: lastLocationId.trim() || null,
      };

      const response = await authApiService.createBattery(body);

      if (response) {
        toast.success("Акумулятор створено");
        props.onApply();
      }
    } catch (err: any) {
      console.error(err);
      toast.error(err?.response?.data?.message || err.message);
    }
  };

  return (
    <div className={styles.container}>
      <form className={styles.form}>
        <EditInput
          title="MAC адреса"
          value={macAddress}
          setValue={(value) => setMacAddress(value)}
          isRequired
        />
        <EditInput
          title="Назва"
          value={name}
          setValue={(value) => setName(value)}
          isRequired
        />
        <div className={styles.field}>
          <label className={styles.label}>
            Локація <span className={styles.require}>*</span>
          </label>
          <select
            className={styles.select}
            value={lastLocation}
            onChange={(event) =>
              setLastLocation(
                event.currentTarget.value as
                  | "terminal"
                  | "warehouse"
                  | "client"
                  | "unknown"
              )
            }
          >
            <option value="warehouse">Склад</option>
            <option value="terminal">Термінал</option>
            <option value="client">Клієнт</option>
            <option value="unknown">Невідомо</option>
          </select>
        </div>
        <EditInput
          title="ID локації"
          value={lastLocationId}
          setValue={(value) => setLastLocationId(value)}
          isRequired={false}
        />
        <EditInput
          title="Різниця напруги (ΔV)"
          value={deltaVoltage}
          setValue={(value) => setDeltaVoltage(value)}
          isRequired={false}
        />
        <EditInput
          title="Нотатка"
          value={note}
          setValue={(value) => setNote(value)}
          isRequired={false}
          isBig
        />
      </form>
      <ModalBottomButtons
        onPressBack={props.onClose}
        onPressApply={onApplyCreateBattery}
        backTitle="Назад"
        applyTitle="Додати акумулятор"
      />
    </div>
  );
};

export default AddBatteryForm;
